export default __webpack_public_path__ + "img/ciUkbQft.48296b08.svg";